var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useMutation } from '@tanstack/react-query';
import mutationFnFactory from './change-payment-due-date-put-mutation';
export function useChangePaymentDueDatePutMutation(_a) {
    var config = _a.config, _b = _a.mutationOptions, mutationOptions = _b === void 0 ? {} : _b;
    return useMutation(__assign({ mutationFn: function (payload) {
            var accountId = payload["cipher.accountId"], accountIdType = payload.accountIdType;
            var keyProps = {
                accountId: accountId,
                accountIdType: accountIdType
            };
            return new Promise(function (resolve, reject) {
                var mutationFn = mutationFnFactory(config, keyProps);
                mutationFn(payload)
                    .then(function (response) {
                    resolve(response);
                })
                    .catch(reject);
            });
        } }, mutationOptions));
}
